
<div class="flex flex-col gap-3 grow">
  <ui-tile-panel #tilePanel id="showcaseDashboard"
    [tilesConfigInput]="sampleTilesConfig"
    [showAllTile]="false"
    [panelTitle]="'Samples'"
    [autoSelectDefaultTile]="true"
    [saveInUserSettings]="false"
    [tileClickAction]="'emitOutput'"
    [panelSettingsName]="'tile-panel-' + 'showcaseDashboard'"
    _tileOrderChanged_="orderPanelsAccordingToTileOrder($event)"
    [initialMode]="'collapsed'"
    [isToggleable]="true"
    (tileClicked)="onSampleTileClicked($event.id)"
    >
  </ui-tile-panel>

@for(samp of sampleComponents(); track samp.className)
{
  @if ([samp.className, "showAll"].includes(selectedPanelName || "")) {
    <ui-panel
      [panelTitle]="samp.showcaseTitle || 'Sample ' + ($index+1)"
      [isToggleable]="selectedPanelName == 'showAll'"
      [collapsed]="selectedPanelName == 'showAll' && $index > 0"
    >
      <markdown *ngIf="samp.showcaseDesc" [data]="resolveSampleDescription(samp.showcaseDesc)" (click)="onMarkdownLinkClick($event)"></markdown>
      <div class="sample-container">
        <ng-container #showcaseSample *ngComponentOutlet="samp.component!"></ng-container>
      </div>
      <div>
        <p-tabs [value]="samp.className + '-html'" (valueChange)="onTabChange()" [selectOnFocus]="true">
          <p-tablist>
            <p-tab [value]="samp.className + '-html'">HTML</p-tab>
            <p-tab [value]="samp.className + '-ts'">TypeScript</p-tab>
            <p-tab [value]="2" *ngIf="samp.scss">SCSS</p-tab>
          </p-tablist>

          <p-tabpanels>

            <!-- HTML -->
            <p-tabpanel [value]="samp.className + '-html'">
              <div class="code-container">
                <ui-button class="copy-btn"
                  [tooltip]="getCopyTooltip(samp.className + '-html')"
                  [pIcon]="getCopyIcon(samp.className + '-html')"
                  [severity]="getCopySeverity(samp.className + '-html')"
                  (click)="copyToClipboard(samp.html || '', samp.className + '-html')">
                </ui-button>
                <pre><code class="language-html" [textContent]="samp.html"></code></pre>
              </div>
            </p-tabpanel>

            <!-- Typescript -->
            <p-tabpanel [value]="samp.className + '-ts'">
              <div class="code-container">
                <ui-button class="copy-btn"
                  [tooltip]="getCopyTooltip(samp.className + '-ts')"
                  [pIcon]="getCopyIcon(samp.className + '-ts')"
                  [severity]="getCopySeverity(samp.className + '-ts')"
                  (click)="copyToClipboard(samp.ts || '', samp.className + '-ts')">
                </ui-button>
                <pre><code class="language-typescript" [textContent]="samp.ts"></code></pre>
              </div>
            </p-tabpanel>

            <!-- Styles -->
            <p-tabpanel [value]="2" *ngIf="samp.scss">
              <div class="code-container">
                <ui-button class="copy-btn"
                  [tooltip]="getCopyTooltip(samp.className + '-scss')"
                  [pIcon]="getCopyIcon(samp.className + '-scss')"
                  [severity]="getCopySeverity(samp.className + '-scss')"
                  (click)="copyToClipboard(samp.scss || '', samp.className + '-scss')">
                </ui-button>
                <pre><code class="language-scss" [textContent]="samp.scss"></code></pre>
              </div>
            </p-tabpanel>

          </p-tabpanels>
        </p-tabs>
      </div>
    </ui-panel>
  }
}
</div>
